<div class="container-fluid">
  <div class="mt-4">
    <!-- <div class="card-header bg-white py-3">
      <h1 class="text-gray-800" style="display: inline-block">
        Manage Import Maps
      </h1>
      
    </div> -->
    
        <!-- Commented on 20th April 2026 for the breadcrumb changes -->

    <!-- <div class="col-6">
      <label for="name" class="form-label">Plant:</label>
      <select
        class="form-select border border-dark"
        name="plantid"
        (change)="getSelectedId($event)"
      >
        <option [defaultSelected]="true" disabled>Select Plant</option>
        <option *ngFor="let plant of plants" [value]="plant.Id">
          {{ plant.Name }}
        </option>
      </select>
    </div> -->

    <div *ngIf="showTable">
      <table
        style="margin-top: 10px"
        datatable
        [dtOptions]="dtoptions"
        class="table table-bordered"
        width="100%"
        *ngIf="importMaps && importMaps.length > 0"
      >
        <thead>
          <tr>
            <th>Default</th>
            <th>Delete</th>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let importMap of importMaps">
            <td><input type="radio" /></td>
            <td><input type="checkbox" class="custom-checkbox" (change)="selectednoOtherUser(importMap.Id)" /></td>
            <td>
              <a class="text-black">{{plantDetails.Name}} / {{ importMap.Name }}</a>
            </td>
          </tr>
        </tbody>
      </table>
      <button *ngIf="importMaps && importMaps.length > 0" class="btn custom-delete-btn" (click)="TheDeleter()">
        Delete
      </button>
    </div>
    <p style="margin-top: 10px" *ngIf="!importMaps || importMaps.length <= 0">
      There are no import maps.
    </p>
  </div>
</div>
